import PlayerCTA from './PlayerCTA'

export default PlayerCTA
// eslint-disable-next-line import/export
export * from './PlayerCTA'
